export const developers = [
    {
        name: "Emaar",
        logo: "/image/Emaar.png",
        slug: "emaar",
        href: "/developers/emaar",
        logoClass: "object-contain scale-75",
        // Image: Burj Khalifa / Downtown Dubai style
        projectImage: "https://images.unsplash.com/photo-1582672060674-bc2bd808a8b5?auto=format&fit=crop&w=1600&q=80",
        about:
            "Emaar Properties is one of the world’s most prestigious real estate developers and the creator of Downtown Dubai and the Burj Khalifa. Known for luxurious communities and international real estate projects."
    },
    {
        name: "Damac",
        logo: "/image/Damac.png",
        slug: "damac",
        href: "/developers/damac",
        logoClass: "object-contain scale-90",
        // Image: High-end luxury interior/villa style
        projectImage: "https://images.unsplash.com/photo-1600607687939-ce8a6c25118c?auto=format&fit=crop&w=1600&q=80",
        about:
            "Damac Properties delivers high-end residential, commercial and leisure projects across Dubai and beyond. Renowned for luxury living experiences, premium amenities, and iconic branded residences."
    },
    {
        name: "Binghatti",
        logo: "/image/binghati.png",
        slug: "binghatti",
        href: "/developers/binghatti",
        logoClass: "object-contain",
        // Image: Modern, angular architecture
        projectImage: "https://images.unsplash.com/photo-1486325212027-8081e485255e?auto=format&fit=crop&w=1600&q=80",
        about:
            "Binghatti Developers is known for innovative architecture and bold design identity. It offers high-quality residences with modern amenities and smart investment value across Dubai’s key communities."
    },
    {
        name: "Meraas",
        logo: "/image/merras.png",
        slug: "meraas",
        href: "/developers/meraas",
        logoClass: "object-contain scale-75",
        // Image: Ain Dubai / Bluewaters style
        projectImage: "https://images.unsplash.com/photo-1624317938116-5050f2b0965c?q=80&w=1170&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
        about:
            "Meraas develops world-class destinations that combine tourism, hospitality, entertainment, and luxury living. The creator of Bluewaters Island and several iconic lifestyle communities in Dubai."
    },
    {
        name: "Sobha Realty",
        logo: "/image/sobha.png",
        slug: "sobha",
        href: "/developers/sobha",
        logoClass: "object-contain bg-yellow-400",
        // Image: Lush green community / Hartland style
        projectImage: "https://images.unsplash.com/photo-1613490493576-7fde63acd811?auto=format&fit=crop&w=1600&q=80",
        about:
            "Sobha Realty is a premium luxury developer offering exceptionally crafted homes with meticulous attention to detail. Famous for ultra-luxury residences and exclusive waterfront communities."
    },
    {
        name: "Aldar Properties",
        logo: "/image/Aldaar.png",
        slug: "aldar",
        href: "/developers/aldar",
        logoClass: "object-contain",
        // Image: Yas Island / Modern round building architecture
        projectImage: "https://images.unsplash.com/photo-1641150557653-e4c409426e59?q=80&w=1025&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
        about:
            "Aldar is Abu Dhabi’s leading real estate developer and the creator of Yas Island landmarks. Focused on large-scale residential and mixed-use destinations designed for modern community living."
    },
    {
        name: "Nakheel",
        logo: "/image/nakheel.png",
        slug: "nakheel",
        href: "/developers/nakheel",
        logoClass: "object-contain",
        // Image: Palm Jumeirah Aerial
        projectImage: "https://images.unsplash.com/photo-1512632578888-169bbbc64f33?auto=format&fit=crop&w=1600&q=80",
        about:
            "Nakheel is the developer behind Palm Jumeirah and multiple waterfront destinations in Dubai. A major contributor to shaping luxury coastal living and large master-planned communities."
    },
    {
        name: "Dubai Properties",
        logo: "https://placehold.co/300x100/ffffff/000000?text=Dubai+Properties",
        slug: "dubai-properties",
        href: "/developers/dubai-properties",
        logoClass: "object-contain",
        // Image: JBR Beachline style
        projectImage: "https://images.unsplash.com/photo-1597659840241-37e2b9c2f55f?auto=format&fit=crop&w=1600&q=80",
        about:
            "Dubai Properties develops landmark communities such as JBR, Mudon and Business Bay. Specialises in family-centric neighbourhoods, mixed-use districts, and waterfront living."
    },
    {
        name: "Azizi",
        logo: "/image/azizi.png",
        slug: "azizi",
        href: "/developers/azizi",
        logoClass: "object-contain",
        // Image: Waterfront / Canal living
        projectImage: "https://images.unsplash.com/photo-1518684079-3c830dcef090?auto=format&fit=crop&w=1600&q=80",
        about:
            "Azizi delivers modern, affordable-luxury communities across Dubai including Al Furjan, Palm Jumeirah, and MBR City. Known for strong investor value and high-demand residential projects."
    },
    {
        name: "Deyaar",
        logo: "/image/deyaar.svg",
        slug: "deyaar",
        href: "/developers/deyaar",
        logoClass: "object-contain",
        // Image: Business Bay Skyline
        projectImage: "https://images.unsplash.com/photo-1477959858617-67f85cf4f1df?auto=format&fit=crop&w=1600&q=80",
        about:
            "Deyaar is a trusted UAE developer with projects across Business Bay, JVC, and Dubai Silicon Oasis. Its portfolio focuses on reliable residential developments and attractive investment properties."
    },
    {
        name: "MAG",
        logo: "/image/mag.png",
        slug: "mag",
        href: "/developers/mag",
        logoClass: "object-contain",
        // Image: Sleek modern living room
        projectImage: "https://images.unsplash.com/photo-1600566753190-17f0baa2a6c3?auto=format&fit=crop&w=1600&q=80",
        about:
            "MAG is known for high-end residential communities, wellness-focused living, and modern architecture. Popular projects include Keturah Reserve and MAG City in Meydan and MBR City."
    },
    {
        name: "Danube",
        logo: "/image/danube.png",
        slug: "danube",
        href: "/developers/danube",
        logoClass: "object-contain",
        // Image: Modern apartment block
        projectImage: "https://images.unsplash.com/photo-1560448204-e02f11c3d0e2?auto=format&fit=crop&w=1600&q=80",
        about:
            "Danube Properties focuses on affordable luxury with premium amenities and flexible payment plans. Well-known for its smart investment projects including Elitz, Pearlz and Miraclz."
    },
    {
        name: "Ellington",
        logo: "/image/Ellington.png",
        slug: "ellington",
        href: "/developers/ellington",
        logoClass: "object-contain",
        // Image: Modern apartment block
        projectImage: "https://i.pinimg.com/1200x/6b/94/d0/6b94d01f101e185f236000fd4b54a7ae.jpg",
        about:
            "Ellington Properties is a Dubai-based luxury property developer known for its design-led residential communities."
    },
    {
        name: "Wasl",
        logo: "/image/Wasl.png",
        slug: "wasl",
        href: "/developers/wasl",
        logoClass: "object-contain",
        // Image: Modern apartment block
        projectImage: "https://i.pinimg.com/1200x/36/77/33/367733c33b179479e0e23a48469d03b1.jpg",
        about:
            "Wasl Properties is a Dubai-based real estate development company known for creating diverse residential and commercial communities."
    }
];


